import React, { useState } from 'react';

import { AIRCRAFT_TYPE_OPTIONS_W_ALL, SELECT_OPTION_ALL } from 'constants';
import { getUTCShortDate } from 'utils';
import { ReportFactory } from 'classes';

import { Row, Col, Button } from 'react-bootstrap';
import DatePicker from 'components/inputs/DatePicker';
import Select from 'components/inputs/Select';
import ReportSummaryOverlay from 'components/overlays/ReportSummaryOverlay';

import styles from './styles.module.css';

const idPrefix = 'UsageReport';
const Usage = (props) => {
  const {
    aircraftMap,
    aircraftList,
    flightId,
    activeFlight,
    fleetFilter,
    onFleetFilterChange,
  } = props;

  if (flightId !== activeFlight?.id) {
    console.error('Flight Id is not same as active flight Id');
  }
  const flight = !flightId ? null : activeFlight;
  const aircraftId = !flight ? null : flight.aircraft_id;
  const aircraft = !aircraftId ? null : aircraftMap?.get(aircraftId);

  let flightArrTimestamp = 0;
  if (flight) {
    if (flight.arrival_timestamp) {
      flightArrTimestamp = new Date(flight.arrival_timestamp).getTime();
    } else {
      const flightLatestHistory = flight?.getLatestHistory() || {};
      const flightLatestHistoryTimestamp = flightLatestHistory.created || 0;
      const ttd = flightLatestHistory.time_to_destination || 0;
      flightArrTimestamp = flightLatestHistoryTimestamp + ttd * 60 * 1000;
    }
  }

  const [shipOption, setShipOption] = useState(
    aircraft ? aircraft.tail : SELECT_OPTION_ALL.value,
  );
  const [arrDt, setArrDt] = useState(flightArrTimestamp);
  const [overlayOpen, setOverlayOpen] = useState(
    flight && aircraft ? true : false,
  );
  const [messageOverlayOpen, setMessageOverlayOpen] = useState(false);
  const [selectedAircraftId, setSelectedAircraftId] = useState(
    aircraftId ? aircraftId : SELECT_OPTION_ALL.value,
  );

  const ships = [SELECT_OPTION_ALL].concat(
    !aircraftList
      ? []
      : (!fleetFilter
          ? aircraftList
          : aircraftList.filter(
              (aircraft) => aircraft?.aircraft_type?.id === fleetFilter,
            )
        )
          .map((aircraft) => {
            return {
              value: aircraft.id,
              name: aircraft.tail,
            };
          })
          .sort((a, b) => a.name.localeCompare(b.name)),
  );

  let arrivalDate = 0;
  if (arrDt > 0) {
    arrivalDate = new Date(arrDt);
    arrivalDate = new Date(arrivalDate.setUTCHours(0, 0, 0, 0)).getTime();
  }

  return (
    <>
      <Row className={styles.root} noGutters>
        <Col>
          <Row className={styles.title} noGutters>
            <Col data-cy-id={`${idPrefix}-ScreenHeader`} className="title_1">
              {' '}
              Usage report{' '}
            </Col>
            <Col md="auto" className={styles.note}>
              Note: Data is available for previous 30 days.
            </Col>
          </Row>
          <Row
            className={styles.filterRow}
            data-cy-id={`${idPrefix}-Filters`}
            noGutters
          >
            <Col>
              <Row className={styles.filterContainer}>
                <Col md="auto" className="mr-5">
                  <Select
                    idPrefix={`${idPrefix}-Fleet`}
                    data-cy-id={`${idPrefix}-FiltersPanel-FleetSelect`}
                    label="Fleet: "
                    options={AIRCRAFT_TYPE_OPTIONS_W_ALL}
                    value={fleetFilter}
                    onChange={(e) => {
                      const {
                        target: { value },
                      } = e;
                      onFleetFilterChange(value);
                      setShipOption(SELECT_OPTION_ALL.value);
                      setSelectedAircraftId(SELECT_OPTION_ALL.value);
                    }}
                  />
                </Col>
                <Col md="auto">
                  <Select
                    idPrefix={`${idPrefix}-Ship`}
                    data-cy-id={`${idPrefix}-FiltersPanel-TailSelect`}
                    label="Tail: "
                    options={ships}
                    value={selectedAircraftId}
                    onChange={(e) => {
                      const {
                        target: { value },
                      } = e;
                      const selectedAircraft = aircraftMap.get(value);
                      setShipOption(
                        selectedAircraft
                          ? selectedAircraft.tail
                          : SELECT_OPTION_ALL.value,
                      );
                      setSelectedAircraftId(value);
                    }}
                  />
                </Col>
                <Col md="auto">
                  <DatePicker
                    idPrefix={`${idPrefix}-FilterPanel-Arrival`}
                    value={arrDt}
                    label="Arrival date:"
                    onChange={(timestamp) => setArrDt(timestamp)}
                    minPreviousDays={30}
                    maxDate={Date.now()}
                  />
                </Col>
              </Row>
            </Col>

            <Col md="auto">
              <Button
                className="button_foc"
                data-cy-id={`${idPrefix}-CreateReportButton`}
                disabled={arrivalDate === 0}
                onClick={() => setOverlayOpen(true)}
              >
                Create report
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <ReportSummaryOverlay
        title="Usage report"
        data={
          <>
            <Row>
              <Col> Fleet </Col>
              <Col>
                {fleetFilter === SELECT_OPTION_ALL.value
                  ? SELECT_OPTION_ALL.name
                  : AIRCRAFT_TYPE_OPTIONS_W_ALL[fleetFilter].name}
              </Col>
            </Row>
            <Row>
              <Col> Tail </Col>
              <Col>
                {' '}
                {shipOption === SELECT_OPTION_ALL.value
                  ? SELECT_OPTION_ALL.name
                  : shipOption}{' '}
              </Col>
            </Row>
            <Row>
              <Col> Arrival date </Col>
              <Col> {getUTCShortDate(arrivalDate)} </Col>
            </Row>
          </>
        }
        isOpen={overlayOpen}
        onCancel={() => setOverlayOpen(false)}
        loading={messageOverlayOpen}
        onDone={async () => {
          setMessageOverlayOpen(true);
          if (shipOption !== SELECT_OPTION_ALL.value) {
            await ReportFactory.getUsageReportByAircraftId(
              selectedAircraftId,
              arrivalDate,
            );
          } else if (fleetFilter !== SELECT_OPTION_ALL.value) {
            await ReportFactory.getUsageReportByAircraftType(
              fleetFilter,
              arrivalDate,
            );
          } else {
            await ReportFactory.getUsageReport(arrivalDate);
          }
          setMessageOverlayOpen(false);
          setOverlayOpen(false);
        }}
      />
    </>
  );
};

export default Usage;
